export const APP_VERSION = 'v1.5.4';
export const BUILD_DATE = '2026-01-17';
